<section class="section-div">
  <div class="header-div">
    <h4><ion-icon name="cash-outline"></ion-icon> Track Record</h4>
  </div>
  <div class="content-details">
    <form action="" [formGroup]="trackrecord">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Total beneficiaries reached at the time of application
              </mat-label>
              <input
                matInput
                placeholder="Enter Total beneficiaries reached"
                type="text"
                readonly="{{ showForm }}"
                formControlName="totalBeneficiaries"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="4"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Total number of manpower with relevant </mat-label>
              <input
                matInput
                placeholder="Enter Total number of manpower"
                type="text"
                readonly="{{ showForm }}"
                formControlName="numberOfManpower"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="4"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Number of physically incubated startups </mat-label>
              <input
                matInput
                placeholder="Enter physically incubated startups"
                type="text"
                readonly="{{ showForm }}"
                formControlName="numberOfIncubatorStartup"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="4"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Number of graduated startups </mat-label>
              <input
                matInput
                placeholder="Enter Number of graduated startups"
                type="text"
                readonly="{{ showForm }}"
                formControlName="numberOfStartup"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="4"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Funds raised so far by the startups (INR) </mat-label>
              <input
                matInput
                placeholder="Enter Funds raised so far"
                type="text"
                readonly="{{ showForm }}"
                formControlName="startupFund"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="9"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
          <p class="numberToWords" *ngIf="setting.startupFund.value">
            {{ setting.startupFund.value | numberToWords }}
          </p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="col-12 mb-2 p-0">
            <h6>Any funds raised for the Incubator</h6>
          </div>
          <div class="mt-3">
            <mat-radio-group
              disabled="{{ showForm }}"
              formControlName="incubatorFundRaised"
              class="example-margin mt-4"
              aria-label="Select an option"
              [ngClass]="{
                'is-invalid':
                  setting.incubatorFundRaised.touched &&
                  setting.incubatorFundRaised.errors
              }"
            >
              <mat-radio-button value="true">Yes</mat-radio-button>
              <mat-radio-button value="false">No</mat-radio-button>
            </mat-radio-group>
            <br />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Total seed funds raised by Incubator (INR) </mat-label>
              <input
                matInput
                placeholder="Enter Funds raised by Incubator"
                type="text"
                readonly="{{ showForm }}"
                formControlName="totalFund"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="9"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
          <p class="numberToWords" *ngIf="setting.totalFund.value">
            {{ setting.totalFund.value | numberToWords }}
          </p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Total number of patents granted through Incubator
              </mat-label>
              <input
                matInput
                placeholder="Enter Number of patents granted"
                type="text"
                readonly="{{ showForm }}"
                formControlName="numberOfPatents"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="4"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Total built-up area available for CoE (sq.ft)</mat-label
              >
              <input
                matInput
                placeholder="Enter built-up area available for CoE"
                type="text"
                readonly="{{ showForm }}"
                formControlName="totalBuiltUpArea"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="5"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Dedicated and Full-time Incubation Head/CEO
              </mat-label>
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Dedicated and Full-time Incubation"
                formControlName="incubationHead"
                maxlength="45"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Number of Full-time Incubation staff </mat-label>
              <input
                matInput
                placeholder="Enter Full-time Incubation staff"
                type="text"
                readonly="{{ showForm }}"
                formControlName="numberOfStaff"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                maxlength="2"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Details of existing facilities relevant to CoE
              </mat-label>
              <textarea
                matInput
                placeholder="Enter Details of existing facilities relevant to CoE"
                readonly="{{ showForm }}"
                formControlName="coeFacilities"
                cols="30"
                rows="3"
                type="text"
                #message
                (keydown.enter)="preventEnterKey($event)"
                maxlength="3000"
              ></textarea>
              <mat-hint matSuffix>{{ message.value.length }}</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="text-center mt-3">
        <button
          mat-raised-button
          color="primary"
          (click)="saveBtn()"
          *ngIf="!showForm"
        >
          Save & Continue
        </button>
      </div>
    </form>
  </div>
</section>
